import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this principle section, it is demonstrated how the audiogram of a listening test participant can be obtained. Please follow the instructions below.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0222/build/es6-bundled/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
